import { render } from "./Home.vue?vue&type=template&id=6ae5f8aa&scoped=true"
import script from "./Home.vue?vue&type=script&lang=ts"
export * from "./Home.vue?vue&type=script&lang=ts"

import "./Home.vue?vue&type=style&index=0&id=6ae5f8aa&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-6ae5f8aa"

export default script